/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PieChart from 'loracoms/PieChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import { toPktPieData } from '../selectors';


const defaultProps = {
  resize: 0,
};

const propTypes = {
  pktData: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  resize: React.PropTypes.number,
};

class GatewayPktPie extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pktData: props.pktData,
      resize: props.resize,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statschart');
  }

  componentWillReceiveProps(nextProps) {
    const { pktData, resize } = nextProps;
    if (pktData !== this.props.pktData) {
      this.setState({ pktData });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize });
    }
  }

  toSeries(pktData) {
    return {
      label: {
        normal: {
          formatter: '{b}\n{d}%',
        },
        emphasis: {
          formatter: '{b}\n{d}%',
        },
      },
      data: [{
        name: this.intlMsg.msg('series.pktsun'),
        value: pktData.pktsun,
        itemStyle: {
          normal: {
            color: '#F7CA18',
          },
        },
        label: {
          normal: {
            position: pktData.pktsun / pktData.pkts < 0.1 ? 'outside' : 'inside',
          },
        },
        labelLine: {
          normal: {
            length: 5,
            length2: 5,
          },
        },
      }, {
        name: this.intlMsg.msg('series.pktsau'),
        value: pktData.pktsau,
        itemStyle: {
          normal: {
            color: '#00B16A',
          },
        },
        label: {
          normal: {
            position: pktData.pktsau / pktData.pkts < 0.1 ? 'outside' : 'inside',
          },
        },
      }],
    };
  }

  render() {
    const { pktData, resize } = this.state;
    return (
      <div className={styles.chart}>
        <PieChart series={[this.toSeries(pktData)]} resize={resize} />
      </div>
    );
  }
}


GatewayPktPie.defaultProps = defaultProps;
GatewayPktPie.propTypes = propTypes;

const mapStateToProps = state => ({
  pktData: toPktPieData(state),
});

export default connect(
  mapStateToProps,
  null,
)(injectIntl(GatewayPktPie));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayPktPie/index.jsx